import { gql } from '@apollo/client';
import { SubscriptionInfoShared } from '../fragments';

export default gql`
  query subscription($id: ID) {
    subscription(id: $id) {
      ...SubscriptionInfoShared
    }
  }
  ${SubscriptionInfoShared}
`;
